import { DialogueUIOptionConfig } from "../../components/ui/YouRespondUI";
import { NurseStationComputerUIConfig } from "../../components/ui/NurseStationComputerUI";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { Segments } from "../../cvp-webgames-core/Scenario/Segments";
import { constants } from "../../misc/constants";
import { CalmBaseScenario, ScoreType, Window508Type } from "../CalmBaseScenario";
import Scenario4 from "./Scenario4";
import { DelegateUIData } from "../../components/ui/DelegateUI";
import { NurseStationComputerSingleQustionUIConfig } from "../../components/ui/NurseStationComputerSingleQuestionUI";

export default class Scenario4Part1 extends BaseScenarioPart<CalmBaseScenario> {

	private partIndx = 0;
	chapterIds = {
		scenario4_1A_s1: 'CALM - Scenario 4 - 1A - Segment 1',
		scenario4_1A_s2: 'CALM - Scenario 4 - 1A - Segment 2'
	}

	constructor(scenario: Scenario4, private onDone: () => void) {
		super(scenario);
		CalmBaseScenario.partIndx = this.partIndx;
	}

	public get videoUrl(): string[] {
		return ['./assets/videos/scenario4/calm-scenario4-avatar' + this.scenario.avatarIndx + '.mp4'];
	}

	public get partId(): string {
		return constants.scenarios.scenario4.parts.level4Part1.id;
	}

	private avatarIcon = () => {
		return 'ChargeNurse' + this.scenario.avatarIndx;
	}

	public start() {
		const context = this;
		this.scenario.displayBeginScenarioUI(
			'./assets/images/scenario4/begin-scenario-scenario4.jpg',
			'calm-scenario4-begin-scenario',
			() => {
				this.scenario.playAmbientLoop(this.scenario.audioHall);
				context.segment1Step1IncomingCall();
			});
	}

	private segment1Step1IncomingCall() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.displayHeader();
		context.scenario.updateObjective('Receive incoming call from Nurse Manager Trista');
		context.playVideoChapter(this.chapterIds.scenario4_1A_s1, () =>
			context.segment1Step2Dialogue())
			
	}

	private segment1Step2Dialogue() {
		this.scenario.destroyAllUIInstances();
		var context = this;		
		this.scenario.dialog(
			'CN-C13-L3-000',
			[{
				text: 'Everything is ready since the staff have been preparing for the past three months.',
				feedback: 'While everyone has been preparing these past few months, you can’t assume that things are perfect. Unexpected situations can arise overnight, like equipment malfunction.',
				scoreType: ScoreType.Worst,
				isCorrect: false // Rank worst
			}, {
				text: 'I’ll take a quick tour of the unit to ensure everything is okay.',
				feedback: 'You should definitely verify that the unit is ready for inspection. However, doing the entire task by yourself can be time consuming and distract you from your regular duties.',
				scoreType: ScoreType.Worst,
				isCorrect: false // Rank worst
			}, {
				text: 'I’ll delegate specific tasks to staff members.',
				scoreType: ScoreType.Best,
				isCorrect: true
			}],
			(selectedOption: DialogueUIOptionConfig) => {
				selectedOption.hide = true; // set hide here
				context.scenario.evaluateAnswer(selectedOption, () => context.segment2Step1GoToNSC(), context.partIndx);
			}
		);
		context.scenario.updateObjective('Select your response');
	}

	private segment2Step1GoToNSC() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.updateObjective('');
		context.playVideoChapter(context.chapterIds.scenario4_1A_s2, () => {
			context.segment2Step2Quiz();
		});
	}

	private segment2Step2Quiz() {
		this.scenario.destroyAllUIInstances();
		var context = this;		
		context.scenario.updateObjective('Select your response');
		context.scenario.update508Window(Window508Type.NurseStationComputerSingleQuestionUI);
		context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.NurseStationComputerSingleQuestionUI, {
			title: 'Which is the best option in delegating unit readiness tasks to the staff?',
			options: [
				{
					text: 'Have each staff member check their patient rooms against the checklist while you take all other areas.',
					isCorrect: false,
					scoreType: ScoreType.Zero,
					feedback: 'Assigning staff members to only check patient rooms is insufficient since Joint Commission surveyors will inspect all areas in the unit and you don\'t have the time to take responsibility for all other areas.'
				},
				{
					text: 'Assign specific tasks from the checklist to different staff members.',
					isCorrect: true,
					scoreType: ScoreType.Best,
					feedback: 'Yes, some tasks can be specifically assigned, such as making sure all medication areas and items are clean and secure. Other tasks, such as ensuring patient rooms are in order, can be accomplished by all staff for their patient rooms. Provide the checklist to help guide their efforts.'
				},
				{
					text: 'Give the checklist to each staff member to check the items on the list.',
					isCorrect: false,
					scoreType: ScoreType.Zero,
					feedback: 'If staff members are given the option to choose items to check, it could lead to confusion with some items checked multiple times and other items not checked at all.'
				}
			],
			onChoiceSelected: (selectedOption: DialogueUIOptionConfig) => {
				context.scenario.updateObjective('');
				context.scenario.evaluateAnswer(selectedOption, () => {}, context.partIndx);
			},
			onClosed: (config: NurseStationComputerSingleQustionUIConfig) => {
				context.segment2Step3DelegateWork();
			},
		}
	)			
		
	}

	private segment2Step3DelegateWork() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		this.scenario.update508Window(Window508Type.DelegateUI)
		const instanceID = this.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.DelegateUI, {
			cNurseImg: this.avatarIcon(),
			onContinueClicked: (data: DelegateUIData) => { 
				this.scenario.update508Window(Window508Type.Main)
				context.scenario.delegateUIScore = data.score;
				context.scenario.gameManager.UiManager.destroyUIInstanceById(instanceID);
				context.onDone();
			}			
		})		
	}
}